import { useEffect, useRef } from "react"
import lottie from "lottie-web"

interface LottieProps {
  /** Parsed Lottie animation JSON. */
  animationData: unknown
  loop?: boolean
  autoplay?: boolean
  className?: string
}

/** Thin reusable wrapper around lottie-web for rendering Lottie JSON animations. */
function Lottie({ animationData, loop = true, autoplay = true, className }: LottieProps) {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!ref.current) return
    const animation = lottie.loadAnimation({
      container: ref.current,
      renderer: "svg",
      loop,
      autoplay,
      animationData,
    })
    return () => animation.destroy()
  }, [animationData, loop, autoplay])

  return <div ref={ref} data-slot="lottie" aria-hidden className={className} />
}

export { Lottie }
